(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qb-offer-teaser"] && !Shopify.designMode) return;
  try {
    var qbFooterUtility = document.querySelector('.qb-footer__utility');
  if (qbFooterUtility) {
    new IntersectionObserver(function(entries) {
      document.body.classList.toggle('qb-footer-utility-visible', entries[0].isIntersecting);
    }).observe(qbFooterUtility);
  }

  (function qbOfferCloseRecovery() {
    var recovering = new WeakSet();

    function offerDialog() {
      var form = document.querySelector('[data-testid="klaviyo-form-Xs6dw9"]');
      return form && form.closest('[role="dialog"]');
    }

    function isStuckClosing(dialog) {
      if (!dialog || !dialog.isConnected) return false;
      var style = window.getComputedStyle(dialog);
      return style.display !== 'none' &&
        style.animationName === 'klaviyo-fadeout' &&
        Number(style.opacity) === 0;
    }

    function finishAnimation(element) {
      if (!element) return;
      var style = window.getComputedStyle(element);
      if (!style.animationName || style.animationName === 'none') return;
      element.dispatchEvent(new AnimationEvent('animationend', {
        animationName: style.animationName,
        elapsedTime: parseFloat(style.animationDuration) || 0,
        bubbles: true
      }));
    }

    function recoverClose() {
      var dialog = offerDialog();
      if (!isStuckClosing(dialog) || recovering.has(dialog)) return;
      recovering.add(dialog);

      // Re-enter the native close action if a teaser animation raced the close.
      // Klaviyo retains control of form state, focus, overlay and scroll locking.
      var close = dialog.querySelector('button[aria-label="Close dialog"]');
      if (close) close.click();

      window.setTimeout(function() {
        if (isStuckClosing(dialog)) {
          // An interrupted/reversed animation may never emit animationend.
          finishAnimation(dialog.querySelector('[data-testid="POPUP"]'));
          finishAnimation(document.querySelector('.kl-teaser-Xs6dw9 [data-testid="animated-teaser"]'));
        }
        recovering.delete(dialog);
      }, 500);
    }

    function scheduleRecovery() {
      var dialog = offerDialog();
      if (!dialog || recovering.has(dialog) || window.getComputedStyle(dialog).display === 'none') return;
      window.setTimeout(recoverClose, 700);
    }

    document.addEventListener('click', scheduleRecovery, true);
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') scheduleRecovery();
    }, true);
    window.addEventListener('klaviyoForms', function(event) {
      if (event.detail && event.detail.formId === 'Xs6dw9' && event.detail.type === 'close') {
        scheduleRecovery();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
